import { RPCs } from "../../../services/rpc.js";
import { NoResults } from "../../../components/NoResults/NoResults.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { ErrorLoadingRetry } from "../../../components/ErrorLoadingRetry.js";
import { useRegionTimezone } from "../../Regions/hooks/useRegionTimezone.js";
import { usePaginationState } from "../../../hooks/usePaginationState/index.js";
import { useLocationContext } from "../../Locations/contexts/LocationContext.js";
import { ServicePeriodInstanceCard } from "../instance/ServicePeriodInstanceCard.js";
import { useActivityEvals } from "../hooks/useActivityEvals.js";
import { buildHistoryInstanceQueryArgs } from "../queries/instance-query.js";
import { groupInstancesByCalendarDay } from "../queries/group-instances-by-day.js";
import { useState } from "react";
import { Loading, Pagination } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RiCalendarScheduleFill } from "react-icons/ri";
//#region src/modules/ServicePeriods/location-panel/ServicePeriodHistoryList.tsx
function ServicePeriodHistoryList() {
	const { location, locationId } = useLocationContext(true);
	const timezone = useRegionTimezone(location.regionId);
	const { recordsPerPage, setRecordsPerPage, setSkippedRecords, skippedRecords } = usePaginationState(`locsvcper_${locationId}_history`, { defaultRecordsPerPage: 25 }, []);
	const [nowIso] = useState(() => (/* @__PURE__ */ new Date()).toISOString());
	const { call, data, error, isCalling, success } = useRPC(RPCs.ServicePeriods.FindServicePeriodInstances.v1, buildHistoryInstanceQueryArgs({
		locationId,
		nowIso,
		pagination: {
			limit: recordsPerPage,
			skip: skippedRecords
		}
	}));
	const rows = data?.servicePeriodInstances ?? [];
	const total = data?.total ?? 0;
	const groups = groupInstancesByCalendarDay(rows, timezone);
	const evals = useActivityEvals({
		locationId,
		sourceRefIds: rows.map((instance) => instance.id)
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "relative mt-xs",
		children: [
			/* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "xxl",
				visible: isCalling && !rows.length
			}),
			(error || evals.error) && /* @__PURE__ */ jsx("div", {
				className: "mb-xs",
				children: /* @__PURE__ */ jsx(ErrorLoadingRetry, { onRetry: error ? call : evals.call })
			}),
			!isCalling && success && !rows.length && /* @__PURE__ */ jsx(NoResults, {
				iconName: RiCalendarScheduleFill,
				text: "No past service periods"
			}),
			!!rows.length && /* @__PURE__ */ jsx("div", {
				className: "flex flex-col gap-base",
				children: groups.map((group) => /* @__PURE__ */ jsxs("section", {
					className: "flex flex-col gap-sm",
					children: [/* @__PURE__ */ jsx("div", {
						className: "z-sticky bg-background sticky top-0 py-xs",
						children: /* @__PURE__ */ jsx("div", {
							className: "text-color-subtle text-sm font-medium",
							children: group.label
						})
					}), group.instances.map((instance) => /* @__PURE__ */ jsx(ServicePeriodInstanceCard, {
						instance,
						runtimeActivityEvals: evals.bySourceRefId[instance.id]
					}, instance.id))]
				}, group.dateKey))
			}),
			total > 0 && /* @__PURE__ */ jsx("div", {
				className: "my-base",
				children: /* @__PURE__ */ jsx(Pagination, {
					onPageClick: setSkippedRecords,
					onSetRecordsPerPage: setRecordsPerPage,
					recordsPerPage,
					showDescription: true,
					skippedRecords,
					totalRecords: total
				})
			})
		]
	});
}
//#endregion
export { ServicePeriodHistoryList };

//# sourceMappingURL=ServicePeriodHistoryList.js.map